module.exports = __webpack_public_path__ + "img/symbol_10.6beeddc8.png";